// Generato da scripts/build-pop-rig.py: non modificare a mano.
// Per ogni pop: ruolo, variante, riquadro intero (w, h) e posizione [x, y, larghezza,
// altezza] di corpo e gambe; le gambe ruotano attorno al centro del loro bordo alto.

export interface Rig {
  id: string;
  role: string;
  variant: number;
  w: number;
  h: number;
  body: [number, number, number, number];
  legL: [number, number, number, number];
  legR: [number, number, number, number];
}

export const RIGS: Rig[] = [
  {
    id: 'POP-001',
    role: 'team-lead',
    variant: 1,
    w: 218.1,
    h: 220,
    body: [0.0, 0.0, 218.1, 197.1],
    legL: [46.9, 180.5, 35.1, 39.5],
    legR: [108.1, 180.5, 35.1, 39.5],
  },
  {
    id: 'POP-002',
    role: 'team-lead',
    variant: 2,
    w: 136.8,
    h: 220,
    body: [0.0, 0.0, 136.8, 197.0],
    legL: [24.4, 180.4, 35.5, 39.6],
    legR: [76.4, 180.4, 35.5, 39.6],
  },
  {
    id: 'POP-003',
    role: 'team-lead',
    variant: 3,
    w: 207.0,
    h: 220,
    body: [0.0, 0.0, 207.0, 197.2],
    legL: [56.7, 180.7, 35.4, 39.3],
    legR: [116.9, 180.7, 35.4, 39.3],
  },
  {
    id: 'POP-004',
    role: 'team-lead',
    variant: 4,
    w: 174.8,
    h: 220,
    body: [0.0, 0.0, 174.8, 197.2],
    legL: [47.2, 180.7, 35.1, 39.3],
    legR: [103.4, 180.7, 35.7, 39.3],
  },
  {
    id: 'POP-005',
    role: 'team-lead',
    variant: 5,
    w: 162.1,
    h: 220,
    body: [0.0, 0.0, 162.1, 197.2],
    legL: [31.2, 180.8, 35.6, 39.2],
    legR: [86.5, 180.8, 35.6, 39.2],
  },
  {
    id: 'POP-006',
    role: 'developer',
    variant: 1,
    w: 156.0,
    h: 220,
    body: [0.0, 0.0, 156.0, 197.2],
    legL: [34.1, 180.7, 35.3, 39.3],
    legR: [88.1, 180.7, 35.8, 39.3],
  },
  {
    id: 'POP-007',
    role: 'developer',
    variant: 2,
    w: 195.1,
    h: 220,
    body: [0.0, 0.0, 195.1, 197.0],
    legL: [49.9, 180.3, 35.2, 39.7],
    legR: [108.7, 180.3, 35.8, 39.7],
  },
  {
    id: 'POP-008',
    role: 'developer',
    variant: 3,
    w: 128.7,
    h: 220,
    body: [0.0, 0.0, 128.7, 197.2],
    legL: [21.9, 180.7, 35.6, 39.3],
    legR: [73.0, 180.7, 35.6, 39.3],
  },
  {
    id: 'POP-009',
    role: 'developer',
    variant: 4,
    w: 197.7,
    h: 220,
    body: [0.0, 0.0, 197.7, 197.2],
    legL: [41.2, 180.7, 35.5, 39.3],
    legR: [100.2, 180.7, 35.5, 39.3],
  },
  {
    id: 'POP-010',
    role: 'developer',
    variant: 5,
    w: 143.1,
    h: 220,
    body: [0.0, 0.0, 143.1, 197.0],
    legL: [33.4, 180.4, 35.3, 39.6],
    legR: [85.9, 180.4, 35.3, 39.6],
  },
  {
    id: 'POP-011',
    role: 'project-manager',
    variant: 1,
    w: 143.1,
    h: 220,
    body: [0.0, 0.0, 143.1, 199.5],
    legL: [21.2, 184.7, 40.3, 35.3],
    legR: [78.6, 184.7, 40.3, 35.3],
  },
  {
    id: 'POP-012',
    role: 'project-manager',
    variant: 2,
    w: 211.6,
    h: 220,
    body: [0.0, 0.0, 211.6, 197.2],
    legL: [46.4, 180.8, 45.9, 39.2],
    legR: [117.7, 180.8, 45.9, 39.2],
  },
  {
    id: 'POP-013',
    role: 'project-manager',
    variant: 3,
    w: 178.4,
    h: 220,
    body: [0.0, 0.0, 178.4, 197.2],
    legL: [36.0, 180.7, 46.0, 39.3],
    legR: [103.6, 180.7, 46.5, 39.3],
  },
  {
    id: 'POP-014',
    role: 'project-manager',
    variant: 4,
    w: 159.2,
    h: 220,
    body: [0.0, 0.0, 159.2, 197.5],
    legL: [23.8, 181.2, 44.7, 38.8],
    legR: [87.7, 181.2, 44.7, 38.8],
  },
  {
    id: 'POP-015',
    role: 'project-manager',
    variant: 5,
    w: 198.7,
    h: 220,
    body: [0.0, 0.0, 198.7, 197.0],
    legL: [32.6, 180.4, 45.9, 39.6],
    legR: [102.2, 180.4, 46.4, 39.6],
  },
  {
    id: 'POP-016',
    role: 'reviewer',
    variant: 1,
    w: 183.8,
    h: 220,
    body: [0.0, 0.0, 183.8, 197.2],
    legL: [43.4, 180.6, 37.3, 39.4],
    legR: [102.6, 180.6, 37.7, 39.4],
  },
  {
    id: 'POP-017',
    role: 'reviewer',
    variant: 2,
    w: 173.1,
    h: 220,
    body: [0.0, 0.0, 173.1, 197.1],
    legL: [40.3, 180.6, 37.3, 39.4],
    legR: [98.1, 180.6, 36.9, 39.4],
  },
  {
    id: 'POP-018',
    role: 'reviewer',
    variant: 3,
    w: 170.7,
    h: 220,
    body: [0.0, 0.0, 170.7, 197.1],
    legL: [44.6, 180.6, 37.8, 39.4],
    legR: [102.9, 180.6, 37.1, 39.4],
  },
  {
    id: 'POP-019',
    role: 'reviewer',
    variant: 4,
    w: 148.6,
    h: 220,
    body: [0.0, 0.0, 148.6, 197.2],
    legL: [27.5, 180.6, 37.7, 39.4],
    legR: [82.9, 180.6, 38.1, 39.4],
  },
  {
    id: 'POP-020',
    role: 'reviewer',
    variant: 5,
    w: 185.6,
    h: 220,
    body: [0.0, 0.0, 185.6, 197.1],
    legL: [59.1, 180.6, 37.7, 39.4],
    legR: [119.1, 180.6, 37.7, 39.4],
  },
  {
    id: 'POP-021',
    role: 'researcher',
    variant: 1,
    w: 138.5,
    h: 220,
    body: [0.0, 0.0, 138.5, 199.1],
    legL: [22.3, 184.0, 38.6, 36.0],
    legR: [77.6, 184.0, 38.6, 36.0],
  },
  {
    id: 'POP-022',
    role: 'researcher',
    variant: 2,
    w: 182.0,
    h: 220,
    body: [0.0, 0.0, 182.0, 197.1],
    legL: [38.1, 180.5, 43.6, 39.5],
    legR: [103.8, 180.5, 43.6, 39.5],
  },
  {
    id: 'POP-023',
    role: 'researcher',
    variant: 3,
    w: 136.9,
    h: 220,
    body: [0.0, 0.0, 136.9, 199.6],
    legL: [34.1, 184.8, 38.5, 35.2],
    legR: [89.1, 184.8, 38.5, 35.2],
  },
  {
    id: 'POP-024',
    role: 'researcher',
    variant: 4,
    w: 186.7,
    h: 220,
    body: [0.0, 0.0, 186.7, 197.1],
    legL: [55.3, 180.5, 43.2, 39.5],
    legR: [121.0, 180.5, 43.8, 39.5],
  },
  {
    id: 'POP-025',
    role: 'researcher',
    variant: 5,
    w: 146.4,
    h: 220,
    body: [0.0, 0.0, 146.4, 198.2],
    legL: [28.5, 182.5, 41.2, 37.5],
    legR: [87.2, 182.5, 41.2, 37.5],
  },
  {
    id: 'POP-026',
    role: 'analyst',
    variant: 1,
    w: 198.8,
    h: 220,
    body: [0.0, 0.0, 198.8, 197.2],
    legL: [48.1, 180.7, 39.3, 39.3],
    legR: [111.4, 180.7, 39.9, 39.3],
  },
  {
    id: 'POP-027',
    role: 'analyst',
    variant: 2,
    w: 127.3,
    h: 220,
    body: [0.0, 0.0, 127.3, 198.9],
    legL: [17.4, 183.7, 35.8, 36.3],
    legR: [68.4, 183.7, 35.8, 36.3],
  },
  {
    id: 'POP-028',
    role: 'analyst',
    variant: 3,
    w: 158.9,
    h: 220,
    body: [0.0, 0.0, 158.9, 197.0],
    legL: [33.2, 180.4, 39.1, 39.6],
    legR: [91.2, 180.4, 38.7, 39.6],
  },
  {
    id: 'POP-029',
    role: 'analyst',
    variant: 4,
    w: 170.3,
    h: 220,
    body: [0.0, 0.0, 170.3, 197.1],
    legL: [31.1, 180.6, 37.4, 39.4],
    legR: [88.7, 180.6, 47.0, 39.4],
  },
  {
    id: 'POP-030',
    role: 'analyst',
    variant: 5,
    w: 179.6,
    h: 220,
    body: [0.0, 0.0, 179.6, 197.0],
    legL: [40.1, 180.4, 37.2, 39.6],
    legR: [99.0, 180.4, 37.2, 39.6],
  },
  {
    id: 'POP-031',
    role: 'qa',
    variant: 1,
    w: 198.9,
    h: 220,
    body: [0.0, 0.0, 198.9, 197.2],
    legL: [59.2, 180.6, 34.3, 39.4],
    legR: [117.2, 180.6, 33.9, 39.4],
  },
  {
    id: 'POP-032',
    role: 'qa',
    variant: 2,
    w: 140.6,
    h: 220,
    body: [0.0, 0.0, 140.6, 197.2],
    legL: [15.9, 180.6, 34.1, 39.4],
    legR: [66.9, 180.6, 33.7, 39.4],
  },
  {
    id: 'POP-033',
    role: 'qa',
    variant: 3,
    w: 182.4,
    h: 220,
    body: [0.0, 0.0, 182.4, 197.0],
    legL: [46.5, 180.4, 33.9, 39.6],
    legR: [102.4, 180.4, 33.5, 39.6],
  },
  {
    id: 'POP-034',
    role: 'qa',
    variant: 4,
    w: 182.5,
    h: 220,
    body: [0.0, 0.0, 182.5, 197.2],
    legL: [53.1, 180.6, 33.8, 39.4],
    legR: [108.7, 180.6, 33.4, 39.4],
  },
  {
    id: 'POP-035',
    role: 'qa',
    variant: 5,
    w: 146.8,
    h: 220,
    body: [0.0, 0.0, 146.8, 197.1],
    legL: [23.3, 180.6, 34.2, 39.4],
    legR: [75.1, 180.6, 33.8, 39.4],
  },
  {
    id: 'POP-036',
    role: 'writer',
    variant: 1,
    w: 150.8,
    h: 220,
    body: [0.0, 0.0, 150.8, 197.1],
    legL: [39.0, 180.4, 34.9, 39.6],
    legR: [91.9, 180.4, 34.9, 39.6],
  },
  {
    id: 'POP-037',
    role: 'writer',
    variant: 2,
    w: 203.8,
    h: 220,
    body: [0.0, 0.0, 203.8, 197.1],
    legL: [50.6, 180.5, 35.7, 39.5],
    legR: [110.8, 180.5, 41.9, 39.5],
  },
  {
    id: 'POP-038',
    role: 'writer',
    variant: 3,
    w: 124.5,
    h: 220,
    body: [0.0, 0.0, 124.5, 197.3],
    legL: [12.6, 180.9, 34.7, 39.1],
    legR: [62.2, 180.9, 34.7, 38.8],
  },
  {
    id: 'POP-039',
    role: 'writer',
    variant: 4,
    w: 161.6,
    h: 220,
    body: [0.0, 0.0, 161.6, 197.1],
    legL: [31.3, 180.6, 35.5, 39.4],
    legR: [86.1, 180.6, 35.9, 39.4],
  },
  {
    id: 'POP-040',
    role: 'writer',
    variant: 5,
    w: 175.9,
    h: 220,
    body: [0.0, 0.0, 175.9, 197.2],
    legL: [49.0, 180.6, 35.4, 39.4],
    legR: [105.7, 180.6, 35.4, 39.4],
  },
  {
    id: 'POP-041',
    role: 'notifier',
    variant: 1,
    w: 158.9,
    h: 220,
    body: [0.0, 0.0, 158.9, 197.0],
    legL: [42.0, 180.4, 38.6, 39.6],
    legR: [99.7, 180.4, 38.2, 39.6],
  },
  {
    id: 'POP-042',
    role: 'notifier',
    variant: 2,
    w: 175.4,
    h: 220,
    body: [0.0, 0.0, 175.4, 197.0],
    legL: [43.5, 180.4, 39.1, 39.6],
    legR: [103.8, 180.4, 39.1, 39.6],
  },
  {
    id: 'POP-043',
    role: 'notifier',
    variant: 3,
    w: 192.9,
    h: 220,
    body: [0.0, 0.0, 192.9, 197.1],
    legL: [48.3, 180.6, 39.0, 39.4],
    legR: [110.3, 180.6, 39.4, 39.4],
  },
  {
    id: 'POP-044',
    role: 'notifier',
    variant: 4,
    w: 193.1,
    h: 220,
    body: [0.0, 0.0, 193.1, 197.2],
    legL: [60.2, 180.8, 39.8, 39.2],
    legR: [123.1, 180.8, 39.8, 39.2],
  },
  {
    id: 'POP-045',
    role: 'notifier',
    variant: 5,
    w: 163.2,
    h: 220,
    body: [0.0, 0.0, 163.2, 197.2],
    legL: [10.7, 180.7, 39.3, 39.3],
    legR: [69.8, 180.7, 39.3, 39.3],
  },
  {
    id: 'POP-046',
    role: 'mail-clerk',
    variant: 1,
    w: 198.9,
    h: 220,
    body: [0.0, 0.0, 198.9, 197.2],
    legL: [60.5, 180.8, 37.6, 39.2],
    legR: [121.7, 180.8, 37.1, 39.2],
  },
  {
    id: 'POP-047',
    role: 'mail-clerk',
    variant: 2,
    w: 166.8,
    h: 220,
    body: [0.0, 0.0, 166.8, 197.0],
    legL: [40.7, 180.4, 37.4, 39.6],
    legR: [98.1, 180.4, 37.4, 39.6],
  },
  {
    id: 'POP-048',
    role: 'mail-clerk',
    variant: 3,
    w: 177.9,
    h: 220,
    body: [0.0, 0.0, 177.9, 197.2],
    legL: [41.8, 180.8, 37.2, 39.2],
    legR: [100.4, 180.8, 37.2, 39.2],
  },
  {
    id: 'POP-049',
    role: 'mail-clerk',
    variant: 4,
    w: 199.7,
    h: 220,
    body: [0.0, 0.0, 199.7, 197.1],
    legL: [46.8, 180.5, 36.9, 39.5],
    legR: [107.6, 180.5, 36.9, 39.5],
  },
  {
    id: 'POP-050',
    role: 'mail-clerk',
    variant: 5,
    w: 194.9,
    h: 220,
    body: [0.0, 0.0, 194.9, 197.0],
    legL: [51.0, 180.4, 37.0, 39.6],
    legR: [111.2, 180.4, 37.0, 39.6],
  },
  {
    id: 'POP-051',
    role: 'triage',
    variant: 1,
    w: 184.2,
    h: 220,
    body: [0.0, 0.0, 184.2, 197.2],
    legL: [48.1, 180.7, 37.3, 39.3],
    legR: [107.3, 180.7, 37.8, 39.3],
  },
  {
    id: 'POP-052',
    role: 'triage',
    variant: 2,
    w: 152.8,
    h: 220,
    body: [0.0, 0.0, 152.8, 197.2],
    legL: [24.1, 180.7, 37.9, 39.3],
    legR: [80.2, 180.7, 43.0, 34.1],
  },
  {
    id: 'POP-053',
    role: 'triage',
    variant: 3,
    w: 180.1,
    h: 220,
    body: [0.0, 0.0, 180.1, 197.1],
    legL: [46.0, 180.5, 38.0, 39.5],
    legR: [105.5, 180.5, 37.5, 39.5],
  },
  {
    id: 'POP-054',
    role: 'triage',
    variant: 4,
    w: 169.8,
    h: 220,
    body: [0.0, 0.0, 169.8, 197.2],
    legL: [34.2, 180.7, 37.9, 39.3],
    legR: [92.7, 180.7, 37.9, 39.3],
  },
  {
    id: 'POP-055',
    role: 'triage',
    variant: 5,
    w: 194.6,
    h: 220,
    body: [0.0, 0.0, 194.6, 197.0],
    legL: [39.9, 180.4, 37.6, 39.6],
    legR: [100.7, 180.4, 37.6, 39.6],
  },
  {
    id: 'POP-056',
    role: 'data-scientist',
    variant: 1,
    w: 221.5,
    h: 220,
    body: [0.0, 0.0, 221.5, 197.1],
    legL: [41.7, 180.6, 41.2, 39.4],
    legR: [109.6, 180.6, 41.2, 39.4],
  },
  {
    id: 'POP-057',
    role: 'data-scientist',
    variant: 2,
    w: 155.1,
    h: 220,
    body: [0.0, 0.0, 155.1, 197.1],
    legL: [18.2, 180.6, 40.7, 39.4],
    legR: [77.4, 180.6, 43.3, 33.9],
  },
  {
    id: 'POP-058',
    role: 'data-scientist',
    variant: 3,
    w: 195.5,
    h: 220,
    body: [0.0, 0.0, 195.5, 197.1],
    legL: [38.5, 180.5, 41.6, 39.5],
    legR: [103.5, 180.5, 41.1, 39.5],
  },
  {
    id: 'POP-059',
    role: 'data-scientist',
    variant: 4,
    w: 168.1,
    h: 220,
    body: [0.0, 0.0, 168.1, 197.2],
    legL: [17.9, 180.7, 41.6, 39.3],
    legR: [79.6, 180.7, 40.7, 39.3],
  },
  {
    id: 'POP-060',
    role: 'data-scientist',
    variant: 5,
    w: 198.1,
    h: 220,
    body: [0.0, 0.0, 198.1, 197.1],
    legL: [42.2, 180.6, 40.9, 39.4],
    legR: [106.9, 180.6, 40.9, 39.4],
  },
  {
    id: 'POP-061',
    role: 'devops',
    variant: 1,
    w: 207.8,
    h: 220,
    body: [0.0, 0.0, 207.8, 197.1],
    legL: [42.1, 180.6, 40.5, 39.4],
    legR: [107.6, 180.6, 41.6, 39.4],
  },
  {
    id: 'POP-062',
    role: 'devops',
    variant: 2,
    w: 131.7,
    h: 220,
    body: [0.0, 0.0, 131.7, 198.7],
    legL: [19.4, 183.2, 36.8, 36.8],
    legR: [72.1, 183.2, 36.8, 36.8],
  },
  {
    id: 'POP-063',
    role: 'devops',
    variant: 3,
    w: 174.2,
    h: 220,
    body: [0.0, 0.0, 174.2, 197.2],
    legL: [42.9, 180.7, 40.3, 39.3],
    legR: [104.3, 180.7, 40.3, 39.3],
  },
  {
    id: 'POP-064',
    role: 'devops',
    variant: 4,
    w: 192.1,
    h: 220,
    body: [0.0, 0.0, 192.1, 197.2],
    legL: [43.2, 180.7, 40.9, 39.3],
    legR: [107.0, 180.7, 41.4, 39.3],
  },
  {
    id: 'POP-065',
    role: 'devops',
    variant: 5,
    w: 196.7,
    h: 220,
    body: [0.0, 0.0, 196.7, 197.2],
    legL: [34.9, 180.8, 39.8, 39.2],
    legR: [98.1, 180.8, 39.2, 39.2],
  },
  {
    id: 'POP-066',
    role: 'web-designer',
    variant: 1,
    w: 191.2,
    h: 220,
    body: [0.0, 0.0, 191.2, 197.1],
    legL: [47.4, 180.6, 36.7, 39.4],
    legR: [107.0, 180.6, 37.1, 39.4],
  },
  {
    id: 'POP-067',
    role: 'web-designer',
    variant: 2,
    w: 198.2,
    h: 220,
    body: [0.0, 0.0, 198.2, 197.1],
    legL: [50.2, 180.6, 35.8, 39.4],
    legR: [109.6, 180.6, 35.3, 39.4],
  },
  {
    id: 'POP-068',
    role: 'web-designer',
    variant: 3,
    w: 177.5,
    h: 220,
    body: [0.0, 0.0, 177.5, 197.0],
    legL: [43.2, 180.4, 36.4, 39.6],
    legR: [100.7, 180.4, 36.4, 39.6],
  },
  {
    id: 'POP-069',
    role: 'web-designer',
    variant: 4,
    w: 238.2,
    h: 220,
    body: [0.0, 0.0, 238.2, 197.0],
    legL: [56.9, 180.4, 37.1, 39.6],
    legR: [122.4, 180.4, 38.1, 39.6],
  },
  {
    id: 'POP-070',
    role: 'web-designer',
    variant: 5,
    w: 164.3,
    h: 220,
    body: [0.0, 0.0, 164.3, 197.1],
    legL: [34.6, 180.6, 36.8, 39.4],
    legR: [91.1, 180.6, 46.0, 36.8],
  },
  {
    id: 'POP-071',
    role: 'home',
    variant: 1,
    w: 184.8,
    h: 220,
    body: [0.0, 0.0, 184.8, 197.2],
    legL: [40.1, 180.7, 40.4, 39.3],
    legR: [102.7, 180.7, 40.9, 39.3],
  },
  {
    id: 'POP-072',
    role: 'home',
    variant: 2,
    w: 174.2,
    h: 220,
    body: [0.0, 0.0, 174.2, 197.0],
    legL: [21.2, 180.4, 40.5, 39.6],
    legR: [82.7, 180.4, 41.0, 39.6],
  },
  {
    id: 'POP-073',
    role: 'home',
    variant: 3,
    w: 179.4,
    h: 220,
    body: [0.0, 0.0, 179.4, 197.1],
    legL: [38.4, 180.6, 40.9, 39.4],
    legR: [101.0, 180.6, 41.4, 39.4],
  },
  {
    id: 'POP-074',
    role: 'home',
    variant: 4,
    w: 171.9,
    h: 220,
    body: [0.0, 0.0, 171.9, 197.2],
    legL: [24.8, 180.7, 40.8, 39.3],
    legR: [86.0, 180.7, 41.8, 39.3],
  },
  {
    id: 'POP-075',
    role: 'home',
    variant: 5,
    w: 211.2,
    h: 220,
    body: [0.0, 0.0, 211.2, 197.2],
    legL: [66.6, 180.8, 40.8, 39.2],
    legR: [132.7, 180.8, 52.7, 39.2],
  },
  {
    id: 'POP-076',
    role: 'translator',
    variant: 1,
    w: 176.6,
    h: 220,
    body: [0.0, 0.0, 176.6, 197.2],
    legL: [37.8, 180.7, 36.2, 39.3],
    legR: [95.0, 180.7, 36.2, 39.3],
  },
  {
    id: 'POP-077',
    role: 'translator',
    variant: 2,
    w: 190.1,
    h: 220,
    body: [0.0, 0.0, 190.1, 197.0],
    legL: [41.2, 180.4, 36.4, 39.6],
    legR: [100.7, 180.4, 36.4, 39.6],
  },
  {
    id: 'POP-078',
    role: 'translator',
    variant: 3,
    w: 148.2,
    h: 220,
    body: [0.0, 0.0, 148.2, 197.1],
    legL: [24.9, 180.6, 36.1, 39.4],
    legR: [78.9, 180.6, 36.1, 39.4],
  },
  {
    id: 'POP-079',
    role: 'translator',
    variant: 4,
    w: 204.4,
    h: 220,
    body: [0.0, 0.0, 204.4, 197.2],
    legL: [70.3, 180.8, 35.7, 39.2],
    legR: [130.5, 180.8, 35.7, 39.2],
  },
  {
    id: 'POP-080',
    role: 'translator',
    variant: 5,
    w: 205.3,
    h: 220,
    body: [0.0, 0.0, 205.3, 197.2],
    legL: [34.5, 180.7, 35.8, 39.3],
    legR: [95.1, 180.7, 36.3, 39.3],
  },
  {
    id: 'POP-081',
    role: 'ux-ui',
    variant: 1,
    w: 205.7,
    h: 220,
    body: [0.0, 0.0, 205.7, 197.0],
    legL: [24.6, 180.4, 43.9, 39.6],
    legR: [93.2, 180.4, 57.5, 37.7],
  },
  {
    id: 'POP-082',
    role: 'ux-ui',
    variant: 2,
    w: 205.4,
    h: 220,
    body: [0.0, 0.0, 205.4, 197.2],
    legL: [30.6, 180.7, 43.7, 39.3],
    legR: [98.9, 180.7, 44.2, 39.3],
  },
  {
    id: 'POP-083',
    role: 'ux-ui',
    variant: 3,
    w: 181.3,
    h: 220,
    body: [0.0, 0.0, 181.3, 197.1],
    legL: [13.1, 180.6, 43.1, 39.4],
    legR: [77.9, 180.6, 43.1, 39.4],
  },
  {
    id: 'POP-084',
    role: 'ux-ui',
    variant: 4,
    w: 195.1,
    h: 220,
    body: [0.0, 0.0, 195.1, 197.1],
    legL: [48.4, 180.6, 42.5, 39.4],
    legR: [114.4, 180.6, 42.5, 39.4],
  },
  {
    id: 'POP-085',
    role: 'ux-ui',
    variant: 5,
    w: 202.2,
    h: 220,
    body: [0.0, 0.0, 202.2, 197.0],
    legL: [59.9, 180.4, 44.8, 39.6],
    legR: [128.9, 180.4, 44.8, 39.6],
  },
  {
    id: 'POP-086',
    role: 'security',
    variant: 1,
    w: 194.9,
    h: 220,
    body: [0.0, 0.0, 194.9, 197.1],
    legL: [49.8, 180.6, 36.7, 39.4],
    legR: [110.1, 180.6, 37.2, 39.4],
  },
  {
    id: 'POP-087',
    role: 'security',
    variant: 2,
    w: 154.3,
    h: 220,
    body: [0.0, 0.0, 154.3, 197.1],
    legL: [31.4, 180.5, 36.3, 39.5],
    legR: [86.2, 180.5, 36.7, 39.5],
  },
  {
    id: 'POP-088',
    role: 'security',
    variant: 3,
    w: 182.2,
    h: 220,
    body: [0.0, 0.0, 182.2, 197.1],
    legL: [40.8, 180.6, 36.8, 39.4],
    legR: [99.4, 180.6, 36.8, 39.4],
  },
  {
    id: 'POP-089',
    role: 'security',
    variant: 4,
    w: 142.5,
    h: 220,
    body: [0.0, 0.0, 142.5, 197.0],
    legL: [30.3, 180.4, 35.9, 39.6],
    legR: [83.4, 180.4, 35.9, 39.6],
  },
  {
    id: 'POP-090',
    role: 'security',
    variant: 5,
    w: 193.1,
    h: 220,
    body: [0.0, 0.0, 193.1, 197.0],
    legL: [46.6, 180.4, 36.8, 39.6],
    legR: [106.9, 180.4, 36.8, 39.6],
  },
  {
    id: 'POP-091',
    role: 'scheduler',
    variant: 1,
    w: 202.4,
    h: 220,
    body: [0.0, 0.0, 202.4, 197.3],
    legL: [55.3, 180.8, 39.8, 39.2],
    legR: [119.5, 180.8, 40.5, 39.2],
  },
  {
    id: 'POP-092',
    role: 'scheduler',
    variant: 2,
    w: 154.5,
    h: 220,
    body: [0.0, 0.0, 154.5, 197.1],
    legL: [36.0, 180.5, 40.0, 39.5],
    legR: [94.7, 180.5, 40.5, 39.5],
  },
  {
    id: 'POP-093',
    role: 'scheduler',
    variant: 3,
    w: 185.8,
    h: 220,
    body: [0.0, 0.0, 185.8, 197.1],
    legL: [34.2, 180.5, 40.1, 39.5],
    legR: [96.3, 180.5, 40.1, 39.5],
  },
  {
    id: 'POP-094',
    role: 'scheduler',
    variant: 4,
    w: 202.6,
    h: 220,
    body: [0.0, 0.0, 202.6, 197.3],
    legL: [62.7, 180.8, 40.4, 39.2],
    legR: [127.4, 180.8, 41.6, 39.2],
  },
  {
    id: 'POP-095',
    role: 'scheduler',
    variant: 5,
    w: 156.5,
    h: 220,
    body: [0.0, 0.0, 156.5, 197.0],
    legL: [31.6, 180.4, 39.6, 39.6],
    legR: [90.1, 180.4, 39.6, 39.6],
  },
];
